"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _semanticUiReact = require("semantic-ui-react");

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _MapStyles = require("./MapStyles.css");

var _MapStyles2 = _interopRequireDefault(_MapStyles);

var _request = require("../../common/request");

var _request2 = _interopRequireDefault(_request);

var _constants = require("../../utils/constants");

var CONSTANTS = _interopRequireWildcard(_constants);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

//     

var MapStyles = function (_React$PureComponent) {
	_inherits(MapStyles, _React$PureComponent);

	function MapStyles(props) {
		_classCallCheck(this, MapStyles);

		var _this = _possibleConstructorReturn(this, (MapStyles.__proto__ || Object.getPrototypeOf(MapStyles)).call(this, props));

		_this.handleClick = function (styleid) {

			//console.info("apastyles",styleid);
			//let _url = this.state.stylesList[styleid].style;
			//_url=_url.replace("orto.json","hiper.json");
			var newStyle = { id: styleid, url: _this.state.stylesList[styleid].style };
			_this.setState({ style: newStyle });
			_this.props.updateMap("style", newStyle);
		};

		_this.state = {
			style: _this.props.vieweroptions.style,
			stylesList: []
		};
		return _this;
	}

	_createClass(MapStyles, [{
		key: "componentDidMount",
		value: function componentDidMount() {

			this.loadStyles();
		}
	}, {
		key: "loadStyles",
		value: function loadStyles() {
			var _this2 = this;

			_request2.default.get(CONSTANTS.URL_GET_ICGC_MAPSTYLES).then(function (data) {

				_this2.setState({ stylesList: data.backgrounds });
			}).catch(function (error) {

				_this2.setState({ stylesList: CONSTANTS.DEFAULT_ICGC_BACKGROUNDS });
			});
		}
	}, {
		key: "makeListItem",
		value: function makeListItem(item) {
			var _this3 = this;

			var classeItem = item.styleid === this.state.style.id ? _MapStyles2.default.itemOptSelected : _MapStyles2.default.itemOpt;

			return _react2.default.createElement(_semanticUiReact.List.Item, {
				key: item.styleid,
				active: item.styleid === this.state.style.id,
				onClick: function onClick(e, data) {
					return _this3.handleClick(item.styleid);
				},
				content: _react2.default.createElement(_semanticUiReact.Image, { src: item.icon, size: "mini", className: _MapStyles2.default.img, verticalAlign: "middle" }),
				description: item.name,
				className: classeItem });
		}
	}, {
		key: "render",
		value: function render() {
			var _this4 = this;

			var stylesList = this.state.stylesList;


			var listItems = stylesList.map(function (item) {
				return _this4.makeListItem(item);
			});

			return _react2.default.createElement(
				_semanticUiReact.Segment,
				null,
				_react2.default.createElement(
					_semanticUiReact.List,
					{ horizontal: true },
					listItems
				)
			);
		}
	}]);

	return MapStyles;
}(_react2.default.PureComponent);

exports.default = MapStyles;


MapStyles.propTypes = {
	jsonMapOptions: _propTypes2.default.object,
	vieweroptions: _propTypes2.default.object,
	updateMap: _propTypes2.default.func
};
